import { useEffect, useMemo } from 'react'
import { useFeatureFlags } from 'components/hooks/useFeatureFlags'

const useCookieConsent = (oneTrustAccessKey: string) => {
  const { getFlag } = useFeatureFlags()
  const releaseCookieConsentBannerTemp = useMemo(
    () => getFlag('releaseCookieConsentBannerTemp') as boolean,
    [getFlag],
  )

  useEffect(() => {
    // External OneTrust script
    if (!oneTrustAccessKey || !releaseCookieConsentBannerTemp) return

    const externalScript = document.createElement('script')
    externalScript.src =
      'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
    externalScript.type = 'text/javascript'
    externalScript.charset = 'UTF-8'

    const externalScriptAutoBlock = document.createElement('script')
    externalScriptAutoBlock.type = 'text/javascript'
    externalScriptAutoBlock.charset = 'UTF-8'

    if (process.env.REACT_APP_ENV !== 'production') {
      externalScript.dataset.domainScript = `${oneTrustAccessKey}-test`
      externalScriptAutoBlock.src = `https://cdn.cookielaw.org/consent/${oneTrustAccessKey}-test/OtAutoBlock.js`
      externalScriptAutoBlock.dataset.domainScript = `${oneTrustAccessKey}-test`
    } else {
      externalScript.dataset.domainScript = `${oneTrustAccessKey}`
      externalScriptAutoBlock.src = `https://cdn.cookielaw.org/consent/${oneTrustAccessKey}/OtAutoBlock.js`
      externalScriptAutoBlock.dataset.domainScript = `${oneTrustAccessKey}`
    }

    // Inline OptanonWrapper function
    const inlineScript = document.createElement('script')
    inlineScript.type = 'text/javascript'
    inlineScript.innerHTML = `
      function OptanonWrapper() {}
    `

    document.head.appendChild(externalScript)
    document.head.appendChild(externalScriptAutoBlock)
    document.head.appendChild(inlineScript)

    // Cleanup on unmount
    return () => {
      document.head.removeChild(externalScript)
      document.head.removeChild(externalScriptAutoBlock)
      document.head.removeChild(inlineScript)
    }
  }, [oneTrustAccessKey, releaseCookieConsentBannerTemp])
}

export default useCookieConsent
